import { put, select } from 'redux-saga/effects';

import makeRequest from 'rdx/utils/makeRequest';
import putErrorActions from 'rdx/utils/putErrorActions';
import { newMessageEvent } from 'rdx/modules/messages/slice';
import { getWebsocketId } from 'rdx/modules/websocket/slice';
import downloadUrl from 'lib/utils/downloadUrl';

function* divaExport({ payload: { action, params = {} } }) {
  const websocketId = yield select(getWebsocketId);
  const finalParams = { ...params };
  if (websocketId) {
    finalParams.socket_id = websocketId;
  }
  const { success, data, error } = yield* makeRequest.action(action, finalParams);
  const presignedUrl = data?.data?.attributes?.presigned_url;
  if (success && presignedUrl && !params.save_file) {
    downloadUrl(presignedUrl);
    yield put(newMessageEvent({ text: 'Download ready' }));
  } else if (success && !params.save_file) {
    yield put(newMessageEvent({ text: 'Preparing export' }));
  } else if (success && params.save_file) {
    yield put(newMessageEvent({ text: 'Zip file is being saved to project files' }));
  } else {
    yield* putErrorActions({ error });
  }
  return null;
}

export default divaExport;
